module.exports = __webpack_public_path__ + "static/img/ecaray_about_introduction_honor23.02cf9223.png";